import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { routes, RouteItem } from "./routes/routes";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import { ConversationsProvider } from "./context/ConversationsListContext";
import { ACCESS_TOKEN } from "./constants";

const renderRoutes = (routesList: Record<string, RouteItem>) => {
  return Object.values(routesList).map((route: RouteItem, index: number) => {
    if (route.children) {
      return (
        <Route
          key={index}
          path={route.path}
          element={
            route.roles.includes("guest") ? (
              route.element
            ) : (
              <ProtectedRoute>{route.element}</ProtectedRoute>
            )
          }
        >
          {renderRoutes(route.children)}
        </Route>
      );
    } else {
      return (
        <Route
          key={index}
          path={route.path}
          element={
            route.roles.includes("guest") ? (
              route.element
            ) : (
              <ProtectedRoute>{route.element}</ProtectedRoute>
            )
          }
        />
      );
    }
  });
};



function RootHandle() {
  const token = localStorage.getItem(ACCESS_TOKEN);
  if(!token){
    return <Navigate to={routes.landingpage.path} />
  }
  return <Navigate to={routes.chat.path} />
}

export default function App() {
  return (
    <Router>
      <ConversationsProvider>
        <Routes>
          <Route path="/" element={<RootHandle />} />
          {renderRoutes(routes)}
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </ConversationsProvider>
    </Router>
  );
}
